import React, { useEffect, useState } from "react";
import "./style.css";
import { Eye, EyeSlash } from "iconsax-react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import googleG from "../../assets/images/google-g.png";
import loginBg from "../../assets/images/login-background.png";
import logoRah from "../../assets/images/logo-rah.png";
// ✅ 1. IMPORT MATRIX HOOK
import { useMatrix } from "../../context/MatrixContext";
import { getAllUserInfo } from "../../Store/UserAction";
import { api } from "../../utils/axios";

function Login({ isSignup = false }) {
	const [email, setEmail] = useState("");
	const [pass, setPass] = useState("");
	const [confirmPass, setConfirmPass] = useState("");
	const [name, setName] = useState("");
	const [teamName, setTeamName] = useState("");

	const [invalidPass, setInvalidPass] = useState(null);
	const [invalidName, setInvalidName] = useState(null);
	const [invalidTeamName, setInvalidTeamName] = useState(null);
	const [invalidEmailPass, setInvalidEmailPass] = useState(false);

	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPass, setConfirmShowPass] = useState(false);

	// Mobile + OTP states
	const [mobile, setMobile] = useState("");
	const [otp, setOtp] = useState("");
	const [otpSent, setOtpSent] = useState(false);
	const [otpSecondsLeft, setOtpSecondsLeft] = useState(0);
	const otpIsRunning = otpSecondsLeft > 0;

	const dispatch = useDispatch();
	const navigate = useNavigate();

	// ✅ 2. INITIALIZE HOOK
	const { initMatrix } = useMatrix();

	// timer effect
	useEffect(() => {
		if (!otpIsRunning) return;
		const t = setInterval(() => {
			setOtpSecondsLeft((s) => (s > 0 ? s - 1 : 0));
		}, 1000);
		return () => clearInterval(t);
	}, [otpIsRunning]);

	const formatTime = (sec) => {
		const m = String(Math.floor(sec / 60)).padStart(2, "0");
		const s = String(sec % 60).padStart(2, "0");
		return `${m}:${s}`;
	};

	// send otp handler
	const sendOtpHandler = async () => {
		const m = mobile.trim();

		if (!/^09\d{9}$/.test(m)) {
			toast.error("شماره موبایل نامعتبر است");
			return;
		}

		try {
			await api.post(
				"/signupOTP",
				{ mobile: m },
				{
					headers: { "Content-Type": "application/json" },
				},
			);

			setOtpSent(true);
			setOtpSecondsLeft(180); // 3 minutes
			toast.success("کد ارسال شد");
		} catch (error) {
			const msg = error?.response?.data?.error || "خطا در ارسال کد";
			toast.error(msg);
		}
	};

	async function submitBtnHandler(e) {
		e.preventDefault();

		if (isSignup) {
			if (!name || name.length < 3) {
				setInvalidName(true);
				return;
			} else setInvalidName(false);

			if (!teamName || teamName.length < 3) {
				setInvalidTeamName(true);
				return;
			} else setInvalidTeamName(false);

			if (confirmPass !== pass) {
				setInvalidPass(true);
				return;
			}

			if (!otpSent) {
				toast.error("ابتدا کد را ارسال کنید");
				return;
			}
			if (otp.trim().length !== 6) {
				toast.error("کد تایید باید ۶ رقم باشد");
				return;
			}
			if (otpSecondsLeft === 0) {
				toast.error("کد منقضی شده، دوباره ارسال کنید");
				return;
			}
		}

		try {
			let data = { email: email, password: pass };

			if (isSignup) {
				data = {
					...data,
					name: name,
					teamName: teamName,
					confirmPass: confirmPass,
					mobile: mobile.trim(),
					otp: otp.trim(),
				};
			}

			const response = await api.post(isSignup ? "/signup" : "/login", data, {
				headers: { "Content-Type": "application/json" },
			});

			// Get the full response data
			const resData = response.data;
			const token = resData.token;

			localStorage.setItem("token", token);

			// ✅ 3. START MATRIX CONNECTION
			// Check if backend sent matrix credentials
			if (resData.matrix && !resData.matrix.error) {
				console.log("🔐 Starting Chat Session...");
				// Save to LocalStorage for page refreshes
				localStorage.setItem("matrix_config", JSON.stringify(resData.matrix));
				// Start the engine
				initMatrix(resData.matrix);
			}
			// -----------------------------

			setInvalidEmailPass(false);
			dispatch(getAllUserInfo());
			toast.success(isSignup ? "ثبت نام موفقیت آمیز" : "ورود موفقیت آمیز");
			navigate("/home");
		} catch (error) {
			console.error(error);
			const msg =
				error?.response?.data?.error || "ایمیل یا رمز عبور نامعتبر است";
			setInvalidEmailPass(true);
			toast.error(msg);
		}
	}

	function nameOnChangeHandler(e) {
		setName(e.target.value);
		setInvalidName(false);
	}

	function teamNameOnChangeHandler(e) {
		setTeamName(e.target.value);
		setInvalidTeamName(false);
	}

	useEffect(() => {
		if (confirmPass !== pass) setInvalidPass(true);
		else setInvalidPass(false);
	}, [confirmPass, pass]);

	useEffect(() => {
		setInvalidName(false);
		setInvalidTeamName(false);
		setInvalidEmailPass(false);
		setInvalidPass(false);

		setPass("");
		setConfirmPass("");
		setEmail("");
		setName("");
		setTeamName("");

		setMobile("");
		setOtp("");
		setOtpSent(false);
		setOtpSecondsLeft(0);
	}, [isSignup]);

	return (
		<div className="login-bg-wrapper">
			<img src={loginBg} alt="login background" className="login-bg-img" />
			<div className="login-content-wrapper">
				<div className="login-form-box">
					<div className="login-logo-box">
						<img src={logoRah} alt="logo rah" className="login-logo-img" />
					</div>

					<h2 className="login-title">
						{isSignup ? "ایجاد حساب کاربری" : "ورود به حساب کاربری"}
					</h2>

					<form className="login-form" onSubmit={submitBtnHandler}>
						{isSignup && (
							<div className="form-group">
								<input
									type="text"
									id="name"
									name="name"
									className="form-control"
									value={name}
									onChange={nameOnChangeHandler}
									autoComplete="name"
									placeholder="نام و نام خانوادگی"
								/>
								{invalidName && (
									<div className={"form-helper text-danger mb-3 px-2"}>
										نام نامعتبر است
									</div>
								)}
							</div>
						)}

						<div className="form-group">
							<input
								type="email"
								id="email"
								name="email"
								className="form-control"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								autoComplete="username"
								placeholder="ایمیل"
							/>
						</div>

						{isSignup && (
							<div className="form-group">
								<input
									type="text"
									id="teamName"
									name="teamName"
									className="form-control"
									value={teamName}
									onChange={teamNameOnChangeHandler}
									placeholder="نام تیم  یا شرکت"
								/>
								{invalidTeamName && (
									<div className={"form-helper text-danger mb-3 px-2"}>
										نام شرکت یا تیم نامعتبر است
									</div>
								)}
							</div>
						)}

						{isSignup && (
							<>
								<div className="form-group">
									<input
										type="tel"
										id="mobile"
										name="mobile"
										className="form-control"
										value={mobile}
										onChange={(e) => setMobile(e.target.value)}
										placeholder="شماره موبایل (مثلا 09123456789)"
										autoComplete="tel"
									/>
									<div style={{ display: "flex", gap: 8, marginTop: 8 }}>
										<button
											type="button"
											className="btn btn-outline-primary"
											onClick={sendOtpHandler}
											disabled={otpIsRunning}
										>
											{otpIsRunning
												? `ارسال مجدد (${formatTime(otpSecondsLeft)})`
												: "ارسال کد"}
										</button>
									</div>
								</div>

								<div className="form-group">
									<input
										type="text"
										inputMode="numeric"
										id="otp"
										name="otp"
										className="form-control"
										value={otp}
										onChange={(e) =>
											setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
										}
										placeholder="کد تایید (۶ رقمی)"
										disabled={!otpSent}
									/>
									{!otpSent && (
										<div className={"form-helper text-danger mb-3 px-2"}>
											اول ارسال کد را بزنید
										</div>
									)}
								</div>
							</>
						)}

						<div className="form-group">
							<input
								type={showPassword ? "text" : "password"}
								id="password"
								name="password"
								className="form-control has-icon"
								value={pass}
								onChange={(e) => setPass(e.target.value)}
								autoComplete="current-password"
								placeholder="رمز عبور"
							/>
							<button
								type="button"
								className="login-input-icon"
								tabIndex={-1}
								style={{
									background: "none",
									border: "none",
									padding: 0,
									cursor: "pointer",
								}}
								onClick={() => setShowPassword((v) => !v)}
								aria-label={showPassword ? "مخفی کردن رمز" : "نمایش رمز"}
							>
								{showPassword ? (
									<EyeSlash size={20} variant="Linear" />
								) : (
									<Eye size={20} variant="Linear" />
								)}
							</button>

							{invalidEmailPass && (
								<div className={"form-helper text-danger mb-3"}>
									ایمیل یا رمز عبور نامعتبر است
								</div>
							)}

							{!isSignup && (
								<Link
									to={"/forgot-password"}
									className={"tw-text-sm tw-px-3 tw-w-fit"}
								>
									رمز عبور خود را فراموش کرده اید؟
								</Link>
							)}
						</div>

						{isSignup && (
							<div className="form-group">
								<input
									type={showConfirmPass ? "text" : "password"}
									id="confirm-password"
									name="confirm-password"
									className="form-control has-icon"
									value={confirmPass}
									onChange={(e) => setConfirmPass(e.target.value)}
									placeholder="تکرار رمز عبور"
								/>
								<button
									type="button"
									className="login-input-icon"
									tabIndex={-1}
									style={{
										background: "none",
										border: "none",
										padding: 0,
										cursor: "pointer",
									}}
									onClick={() => setConfirmShowPass((v) => !v)}
									aria-label={showConfirmPass ? "مخفی کردن رمز" : "نمایش رمز"}
								>
									{showConfirmPass ? (
										<EyeSlash size={20} variant="Linear" />
									) : (
										<Eye size={20} variant="Linear" />
									)}
								</button>

								{invalidPass && (
									<div className={"form-helper text-danger mb-3"}>
										رمز عبور با تکرار آن یکسان نیست
									</div>
								)}
							</div>
						)}

						<div className="form-btn-group">
							<button type="submit" className="btn btn-primary">
								{isSignup ? "ثبت نام" : "ورود"}
							</button>
						</div>

						<button type="button" className="google-btn">
							<img src={googleG} alt="Google" className="google-icon" />
							{isSignup ? "ثبت نام با Google" : "ورود با Google"}
						</button>
					</form>

					<div className="switch-link">
						{isSignup ? (
							<>
								در حال حاضر حساب کاربری دارید؟
								<Link to={"/login"}>ورود به حساب</Link>
							</>
						) : (
							<>
								هنوز حساب خود را ایجاد نکرده اید؟
								<Link to={"/signup"}>ثبت نام</Link>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export default Login;
